export default __webpack_public_path__ + "static/media/151.1b2c1ec7.jpg";